import { RootState } from 'reducers';
import { formValueSelector } from 'redux-form';
import { Props } from './index';
import { FormData } from './constraints';

export const mapStateToProps = (state: RootState, { form }: Props) => ({
  quantity: formValueSelector(form)(state, 'quantity') as FormData['quantity'],
});

export type StateToProps = ReturnType<typeof mapStateToProps>;
